import type { ComponentType } from 'react';
import { AuditLog, SystemSettings, UserManagement } from './screens';

/**
 * The administration screens, shared by every module.
 *
 * This is the Phase 8 consolidation in one object: the same three components are
 * mounted under all four modules' admin navs, so there is one User Management,
 * one System Settings and one Audit Log — not the three partial copies the
 * legacy apps each carried.
 *
 * The screens are module-aware only where it helps: System Settings and the
 * audit log default to the module you navigated from. Users and roles are
 * genuinely global, so those screens are not scoped by the URL at all — what an
 * administrator may change is decided by RLS from their own grants.
 */
export const ADMIN_SCREENS: Record<string, ComponentType> = {
  'user-management': UserManagement,
  'system-settings': SystemSettings,
  'audit-log': AuditLog,
};
